<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">Permissions — {{ data.name }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>
  <span class="dialog-sub">Grant or deny individual view-permissions on top of the operator's role.</span>

  <!-- ADD -->
  <div class="add-row">
    <div class="field grow">
      <span class="field-label">View-permission</span>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="svpId">
          @for(c of catalog; track c.svpId){
          <mat-option [value]="c.svpId">{{ c.viewLabel }} — {{ c.permission }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="field">
      <span class="field-label">Effect</span>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="effect">
          <mat-option [value]="'GRANT'">Grant</mat-option>
          <mat-option [value]="'DENY'">Deny</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="field">
      <span class="field-label">Valid until (optional)</span>
      <input type="date" class="text-box-active" [formControl]="validUntil" />
    </div>
    <button type="button" class="ac-primary-btn" (click)="add()">Add</button>
  </div>

  <!-- CURRENT -->
  <div class="section-title">Current overrides</div>
  @if(overrides.length){
  <div class="ovr-list">
    @for(o of overrides; track o.supdId){
    <div class="ovr-row">
      <span>
        <b [class.deny]="o.effect === 'DENY'">{{ o.effect }}</b>
        {{ o.viewLabel }} — {{ o.permission }}
        @if(o.validUntil){ <span class="muted">(until {{ o.validUntil }})</span> }
      </span>
      <button type="button" class="ac-secondary-small-btn" (click)="remove(o)">Remove</button>
    </div>
    }
  </div>
  } @else {
  <p class="muted">No per-user overrides.</p>
  }

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
